import { render, staticRenderFns } from "./RSelect.vue?vue&type=template&id=1f04263f&scoped=true"
import script from "./RSelect.vue?vue&type=script&lang=js"
export * from "./RSelect.vue?vue&type=script&lang=js"
import style0 from "./RSelect.vue?vue&type=style&index=0&id=1f04263f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04263f",
  null
  
)

export default component.exports